export default function({ data, key }) {
  const places = Array.from(new Set(data.map(d => d[key])))
  return places
}
